export default __webpack_public_path__ + "static/media/autos_nuevos.fbfc1012.svg";